import { Component } from '@angular/core';

@Component({
  selector: 'app-heading-loader',
  templateUrl: './heading-loader.component.html',
  styleUrls: ['./heading-loader.component.css']
})
export class HeadingLoaderComponent {

}
